export default "__VITE_ASSET__B69hTzwH__"